import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setTokenAccessor } from '@/services/api';

export function TokenBridge() {
  const { getToken } = useAuth();

  useEffect(() => {
    setTokenAccessor(getToken);
  }, [getToken]);

  return null;
}
